export default "__VITE_ASSET__ff27c805__$_?nuxt_component=async&nuxt_component_name=SvgoFreenem__"